<div class="scss-clipboard-card-scroll-title d-flex justify-content-between align-items-start padding-y-8 padding-left-16 padding-right-8">
    <div class="d-flex flex-column gap-space-16 typography-body-small padding-y-8">
        <div class="typography-body-medium-strong">
            <ng-content select="[title]"></ng-content>
        </div>
        <ng-content select="[subtitle]"></ng-content>
    </div>
    <lib-icon-button
        [icon]="Icon.Common.ContentCopy"
        [size]="ButtonSize.Small"
        [kind]="ButtonKind.NeutralTertiary"
        (clicked)="Copy()">
    </lib-icon-button>
</div>
<div class="scss-clipboard-card-scroll-body-outer">
    <div class="scss-clipboard-card-scroll-body-inner padding-16 typography-body-medium" #content>
        <ng-content select="[body]"></ng-content>
    </div>
</div>
